"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
class StickyBox {
    constructor(targetElement, parentElement) {
        this.targetElement = targetElement;
        this.parentElement = parentElement;
        this.bindSetStickyContainerClasses = this.setStickyContainerClasses.bind(this);
        this.init();
    }
    init() {
        const self = this;
        if (ScreenSize_1.default.isSmallScreen()) {
            this.destroy();
        }
        else {
            this.create();
        }
        window.addEventListener('resize', () => {
            if (ScreenSize_1.default.isSmallScreen()) {
                self.destroy();
            }
            else {
                self.create();
            }
        });
    }
    create() {
        window.addEventListener('scroll', this.bindSetStickyContainerClasses);
        window.addEventListener('resize', this.bindSetStickyContainerClasses);
    }
    destroy() {
        window.removeEventListener('scroll', this.bindSetStickyContainerClasses);
        window.removeEventListener('resize', this.bindSetStickyContainerClasses);
        this.removeAllStickyBoxClasses();
    }
    setStickyContainerClasses() {
        const scrollTop = window.scrollY;
        const domRect = this.parentElement.getBoundingClientRect();
        const topBoundary = domRect.top + scrollTop;
        const bottomBoundary = domRect.bottom + scrollTop;
        const targetElementHeight = this.targetElement.offsetHeight;
        const windowHeight = window.innerHeight;
        const parentElementHeight = this.parentElement.offsetHeight;
        const isSmallScreen = ScreenSize_1.default.isSmallScreen();
        const bottomEdgeOfTargetElement = scrollTop + targetElementHeight;
        const boxFitsWindowVertically = targetElementHeight < windowHeight;
        const boxFitsBetweenBoundaries = targetElementHeight < (bottomBoundary - topBoundary);
        // sticky box is completely disabled
        if (!boxFitsWindowVertically || !boxFitsBetweenBoundaries || isSmallScreen) {
            this.removeAllStickyBoxClasses();
        }
        if (windowHeight > targetElementHeight && parentElementHeight > targetElementHeight) {
            // scrolled below top boundary → box is fixed to screen top
            if (scrollTop > topBoundary && bottomEdgeOfTargetElement < bottomBoundary) {
                this.targetElement.classList.add('fixed');
                this.targetElement.classList.remove('stick-to-bottom');
            }
            // scrolled bellow bottom boundary → box is stuck to bottom
            if (bottomEdgeOfTargetElement > bottomBoundary) {
                this.targetElement.classList.remove('fixed');
                this.targetElement.classList.add('stick-to-bottom');
            }
            // scrolled above top boundary → box is displayed normally
            if (this.targetElement.classList.contains('fixed') && scrollTop <= topBoundary) {
                this.targetElement.classList.remove('fixed');
            }
        }
    }
    removeAllStickyBoxClasses() {
        this.targetElement.classList.remove('fixed', 'stick-to-bottom');
    }
}
exports.default = StickyBox;
